<template>
	<div class="card shadow-sm mb-2" @mouseover="hover = true" @mouseleave="hover = false" :class="{ shadow: hover }"
		@click="onClickItem(item)">
		<div class="card-body p-1" :class="!item.isViewed ? 'unread-color' : ''">
			<div class="form-row">
				<div class="col-md-2 pt-3 pl-3">
					<img :src="iconRenderer(item.type)" alt width="45" />
				</div>
				<div class="col-md-10 pt-2">
					<div class="row chat-header">
						<div class="col-md-12 text-left">
							<h6>{{ item.title }}</h6>
						</div>
					</div>
					<div class="row chat-body">
						<div class="col-md-12">{{ item.content }}</div>
					</div>
					<div v-if="dispatchId" class="row chat-body">
						<div class="col-md-12">
							<b-link @click="openDispatchDetails(item)" class="pl-0">See Details of {{ dispatchId }}</b-link>
						</div>
					</div>
					<div v-if="incidentId" class="row chat-body">
						<div class="col-md-12">
							<b-link @click="openIncidentDetails(item)" class="pl-0">See Details of {{ incidentId }}</b-link>
						</div>
					</div>
					<div class="row chat-footer">
						<div class="col-md-12 text-right" style="color: #999b9e">
							<time-ago :refresh="60" :datetime="dateSent" locale="en" :tooltip="true"
								:style="{ 'font-size': '8px' }" long />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// Component
import dispatch from '@/assets/images/notifications/dispatch.svg';
import inTransit from '@/assets/images/notifications/in-transit.svg';
import receive from '@/assets/images/notifications/receive.svg';
import welcome from '@/assets/images/notifications/welcome.svg';
import locked from '@/assets/images/notifications/locked.svg';
import changeLocation from '@/assets/images/notifications/change-location.svg';
import incidentReport from '@/assets/images/notifications/incident-report.svg';

// Util
import { DateUtil } from '@/utils/dateutil';

// Others
import { db } from '@/config/firebase';
import TimeAgo from 'vue2-timeago';
import config from '@/config/env-constants';

export default {
	name: 'NotificationItem',
	components: { TimeAgo },
	data() {
		return {
			hover: false,
			icons: {
				dispatch,
				inTransit,
				receive,
				welcome,
				locked,
				changeLocation,
				incidentReport,
			},
		};
	},
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
	computed: {
		dateSent() {
			return DateUtil.getFormattedDateWithTime(this.item.dateSent);
		},
		dispatchId() {
			const item = this.item;
			if (item.meta && !item.meta.dispatchId) {
				return null;
			}

			return item.meta.dispatchId;
		},
		incidentId() {
			const item = this.item;
			if (item.meta && !item.meta.incidentId) {
				return null;
			}

			return item.meta.incidentId;
		},
	},
	methods: {
		async onClickItem(item) {
			if (item.isViewed) return;

			try {
				const query = await db.collection('notifications').doc(item.id);
				return query.update({ isViewed: true });
			} catch (error) {
				this.$toaster.error(
					'Error loading data. Please reload the page again.'
				);
			}
		},
		iconRenderer(type) {
			let icon;
			if (type === config.notificationType.NEW_COMPANY) {
				icon = this.icons.welcome;
			} else if (type === config.notificationType.DISPATCH_DEPLOYED) {
				icon = this.icons.dispatch;
			} else if (type === config.notificationType.DISPATCH_IN_TRANSIT) {
				icon = this.icons.inTransit;
			} else if (type === config.notificationType.DISPATCH_RECEIVED) {
				icon = this.icons.receive;
			} else if (type === config.notificationType.LOCKED_ACCOUNT) {
				icon = this.icons.locked;
			} else if (type === config.notificationType.UNLOCKED_ACCOUNT) {
				icon = this.icons.welcome;
			} else if (type === config.notificationType.CHANGE_LOCATION) {
				icon = this.icons.changeLocation;
			} else if (type === config.notificationType.INCIDENT_REPORT) {
				icon = this.icons.incidentReport;
			} else {
				// Default mail icon
				icon =
					'https://images.clipartlogo.com/files/istock/previews/7702/77021021-email-colored-vector-icon.jpg';
			}

			return icon;
		},
		async openDispatchDetails(notification) {
			const dispatchId = notification.meta
				? notification.meta.dispatchId
				: null;
			this.$store.commit('notificationDispatchDetails/TOGGLE_DIALOG');

			if (dispatchId) {
				db.collection('dispatches')
					.where('dispatchId', '==', dispatchId)
					.get()
					.then((querySnapshots) => {
						let dispatches = [];
						querySnapshots.forEach((doc) => {
							dispatches.push(doc.data());
						});

						if (dispatches.length > 0) {
							this.$store.commit(
								'notificationDispatchDetails/SET_DISPATCH',
								dispatches[0]
							);
						}
					});
			}
		},

		async openIncidentDetails(notification) {
			const incidentId = notification.meta
				? notification.meta.incidentId
				: null;
			this.$store.commit('notificationIncidentDetails/TOGGLE_DIALOG');

			if (incidentId) {
				db.collection('incidentReports')
					.where('incidentId', '==', incidentId)
					.get()
					.then((querySnapshots) => {
						let dispatches = [];
						querySnapshots.forEach((doc) => {
							dispatches.push(doc.data());
						});

						if (dispatches.length > 0) {
							this.$store.commit(
								'notificationIncidentDetails/SET_INCIDENT',
								dispatches[0]
							);
						}
					});
			}
		},
	},
};
</script>

<style scoped>
.card {
	width: 376px;
	border: none;
	cursor: pointer;
}

.chat-header {
	padding: 4px 10px;
}

.chat-body {
	padding: 0px 10px 0px 10px;
}

.chat-footer {
	padding: 5px 10px;
}

.unread-color {
	background-color: #e7edf8;
}
</style>